import { createAction, props } from '@ngrx/store';
import { FlamingoTypes } from '@mode/shared/contract-common';
import { SwitchViewDomain } from '@mode/shared/contract-common';

export const makeOriginalAttrs = createAction('[SwitchAttrs] Make Original Attrs');
export const restoreOriginalAttrs = createAction('[SwitchAttrs] Restore Original Attrs');

export const createSwitchViewAttr = createAction(
  '[SwitchAttrs] Create Attr',
  props<{
    attr: FlamingoTypes.ModeCalc;
    token: string;
  }>()
);

export const createSwitchViewAttrFromDataview = createAction(
  '[SwitchAttrs] Create Attr From DataView',
  props<{
    attr: FlamingoTypes.ModeCalc;
    token: string;
  }>()
);

export const createSwitchViewAttrSuccess = createAction(
  '[SwitchAttrs] Create Attr Success',
  props<{
    attr: SwitchViewDomain.SwitchAttr;
    token: string;
  }>()
);

export const createSwitchViewAttrFromDataViewSuccess = createAction(
  '[SwitchAttrs] Create Attr From Data View Success',
  props<{
    attr: SwitchViewDomain.SwitchAttr;
    token: string;
  }>()
);

export const createSwitchViewAttrFailure = createAction(
  '[SwitchAttrs] Create Attr Failure',
  props<{
    error: any;
  }>()
);

export const updateSwitchViewAttr = createAction(
  '[SwitchAttrs] Update Attr',
  props<{
    attr: FlamingoTypes.ModeCalc;
    token: string;
    /**
     * @todo(@kevinjamesus86) These are still needed for non-GF code paths.
     * We can remove this after GF is full time
     */
    prevAttr: FlamingoTypes.ModeCalc;
    queryToken: string;
  }>()
);

export const updateSwitchViewAttrFromDataView = createAction(
  '[SwitchAttrs] Update Attr From DataView',
  props<{
    attr: FlamingoTypes.ModeCalc;
    token: string;
    /**
     * @todo(@kevinjamesus86) These are still needed for non-GF code paths.
     * We can remove this after GF is full time
     */
    prevAttr: FlamingoTypes.ModeCalc;
    queryToken: string;
  }>()
);

export const updateSwitchViewAttrSuccess = createAction(
  '[SwitchAttrs] Update Attr Success',
  props<{
    attr: SwitchViewDomain.SwitchAttr;
    token: string;
    // Needed for [legacy] effects that trigger a flamingo select
    // when an attribute is updated.
    // @todo(@kevinjamesus86) remove this in a post-GF world
    // where switchview tokens are the unique identifier
    queryToken: string;
  }>()
);

export const updateSwitchViewAttrFromDataViewSuccess = createAction(
  '[SwitchAttrs] Update Attr From Data View Success',
  props<{
    attr: SwitchViewDomain.SwitchAttr;
    token: string;
    queryToken: string;
  }>()
);

export const updateSwitchViewAttrFailure = createAction(
  '[SwitchAttrs] Update Attr Failure',
  props<{
    error: any;
  }>()
);

export const deleteSwitchViewAttr = createAction(
  '[SwitchAttrs] Delete Attr',
  props<{
    attr: FlamingoTypes.ModeCalc;
    token: string;
    // Needed for [legacy] effects that trigger a flamingo select
    // when an attribute is updated.
    // @todo(@kevinjamesus86) remove this in a post-GF world
    // where switchview tokens are the unique identifier
    queryToken: string;
  }>()
);

export const deleteSwitchViewAttrFromDataView = createAction(
  '[DataView] Delete Attr',
  props<{
    attr: FlamingoTypes.ModeCalc;
    token: string;
    // Needed for [legacy] effects that trigger a flamingo select
    // when an attribute is updated.
    // @todo(@kevinjamesus86) remove this in a post-GF world
    // where switchview tokens are the unique identifier
    queryToken: string;
  }>()
);

export const deleteSwitchViewAttrSuccess = createAction(
  '[SwitchAttrs] Delete Attr Success',
  props<{
    attr: FlamingoTypes.ModeCalc;
    token: string;
    // Needed for [legacy] effects that trigger a flamingo select
    // when an attribute is updated.
    // @todo(@kevinjamesus86) remove this in a post-GF world
    // where switchview tokens are the unique identifier
    queryToken: string;
  }>()
);

export const deleteSwitchViewAttrFailure = createAction(
  '[SwitchAttrs] Delete Attr Failure',
  props<{
    error: any;
  }>()
);

export type MakeOriginalAttrs = ReturnType<typeof makeOriginalAttrs>;
export type RestoreOriginalAttrs = ReturnType<typeof restoreOriginalAttrs>;
export type CreateSwitchViewAttr = ReturnType<typeof createSwitchViewAttr>;
export type CreateSwitchViewAttrFromDataView = ReturnType<typeof createSwitchViewAttr>;
export type CreateSwitchViewAttrSuccess = ReturnType<typeof createSwitchViewAttrSuccess>;
export type CreateSwitchViewAttrFailure = ReturnType<typeof createSwitchViewAttrFailure>;
export type UpdateSwitchViewAttr = ReturnType<typeof updateSwitchViewAttr>;
export type UpdateSwitchViewAttrFromDataView = ReturnType<typeof updateSwitchViewAttr>;
export type UpdateSwitchViewAttrSuccess = ReturnType<typeof updateSwitchViewAttrSuccess>;
export type UpdateSwitchViewAttrFailure = ReturnType<typeof updateSwitchViewAttrFailure>;
export type DeleteSwitchViewAttr = ReturnType<typeof deleteSwitchViewAttr>;
export type DeleteSwitchViewAttrFromDataView = ReturnType<typeof deleteSwitchViewAttr>;
export type DeleteSwitchViewAttrSuccess = ReturnType<typeof deleteSwitchViewAttrSuccess>;
export type DeleteSwitchViewAttrFailure = ReturnType<typeof deleteSwitchViewAttrFailure>;

export type Union =
  | MakeOriginalAttrs
  | RestoreOriginalAttrs
  | CreateSwitchViewAttr
  | CreateSwitchViewAttrFromDataView
  | CreateSwitchViewAttrSuccess
  | CreateSwitchViewAttrFailure
  | UpdateSwitchViewAttr
  | UpdateSwitchViewAttrFromDataView
  | UpdateSwitchViewAttrSuccess
  | UpdateSwitchViewAttrFailure
  | DeleteSwitchViewAttr
  | DeleteSwitchViewAttrFromDataView
  | DeleteSwitchViewAttrSuccess
  | DeleteSwitchViewAttrFailure;
